import React from 'react';
import styled from 'styled-components';
import Typography from '@pedidosya/web-fenix/foundations/Typography';
import OverlayLoader from '@/src/components/OverlayLoader';
import PageTitle from '@/src/components/PageTitle';

const Container = styled.div``;

const Layout = ({
  title = '',
  subtitle = '',
  withMobileMarginBottom = false,
  isLoading = false,
  onBack = () => {},
  children,
}) => (
  <Container>
    {isLoading && <OverlayLoader />}
    <PageTitle
      title={title}
      withMobileMarginBottom={withMobileMarginBottom}
      onBack={onBack}
    />
    {!!subtitle && (
      <Typography
        token="font-body-midcontrast-sentence-medium"
        color="text-color-tertiary"
        style={{ margin: '0 16px 24px' }}
      >
        {subtitle}
      </Typography>
    )}
    {children}
  </Container>
);

export default Layout;
